import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

// Initialize Firebase to connect with React:

firebase.initializeApp(firebaseConfig);

// auth method build in firebase for login

export const auth = firebase.auth();

// firestore - provider to cannect to firebase database collections

export const firestore = firebase.firestore();

// storage
export const storage = firebase.storage();
